// eslint-disable-next-line no-shadow
enum TaleCategory {
  OUTSIDE = 'OUTSIDE',
  INSIDE = 'INSIDE',
  COMMUTING = 'COMMUTING',
  WALKING = 'WALKING',
}

export default TaleCategory
